var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"panel-view"},[_c('a-spin',{attrs:{"tip":"Loading...","spinning":_vm.$store.state.loading}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }